<template>
	<card>
		<h6 slot="header">Rapporto tecnico</h6>
		<div class="row">
			<div
				v-for="(field,$index) in fields"
				:key="$index"
				:class="field.classes">
				<base-input
					tabindex="0"
					v-if="field.type !== 'select' && field.type !== ''"
					:label="field.label"
					:error="getError(field.label)"
					v-model="model.techinicalDetails[$index]"
					:name="field.label"
					:type="field.nativeType === undefined ? 'text' : field.nativeType"
					:step="field.step ? field.step : 1"
					input-size="form-control-lg"
					:placeholder="field.placeholder ? field.placeholder : `Inserisci ${field.label}`" />
				<div class="form-group" v-else>
					<label :for="`fieldTechnical${$index}`">{{field.label}}</label>
					<el-select
						tabindex="0"
						:id="`fieldTechnical${$index}`"
						v-model="model.techinicalDetails[$index]"
						filterable
						allow-create
						default-first-option
						size="large"
						v-if="field.type === 'select' " 
						placeholder="Seleziona se effettuato">
						<el-option
							v-for="item in field.values"
							:key="`${$index}-opt-${item? item: '--'}`"
							:label="item"
							:value="item"/>
					</el-select>
				</div>
			</div>
		</div>


		<div class="row">
			<div class="col-12">
				<h6 class="my-5">Cilindri</h6>

			</div>
		</div>

		<div class="row row-pistons">
			<div class="col-1 col-label">n°</div>
			<div class="col col-value col-header">Pressione (bar)</div>
			<div class="col col-value col-header">Temperatura (°C)</div>
		</div>
		<br>
		<div class="row" v-for="(pistonNumber,$index) in pistonsArray" :key="$index">
			<div class="col-2 col-md-1 col-label">
				{{pistonNumber}}
			</div>
			<div class="col col-value">
				<base-input
					v-model="model.techinicalDetails[`piston${pistonNumber}Pressure`]"
					:name="`piston${pistonNumber}Pressure`"
					type="text"
					input-size="form-control-lg"
					:placeholder="`Pressione`" />
			</div>
			<div class="col col-value">
				<base-input
					v-model="model.techinicalDetails[`piston${pistonNumber}Temperature`]"
					:name="`piston${pistonNumber}Temperature`"
					type="text"
					input-size="form-control-lg"
					:placeholder="`Temperatura`" />
			</div>
		</div>
	</card>
</template>
<style type="text/css">
	
	.col-five,
	.col-sm-five,
	.col-md-five,
	.col-lg-five,
	.col-xl-five {
	    position: relative;
	    width: 100%;
	    min-height: 1px;
	    padding-right: 15px;
	    padding-left: 15px;
	}
	.col-five {
	    -webkit-box-flex: 0;
	    -ms-flex: 0 0 20%;
	    flex: 0 0 20%;
	    max-width: 20%;
	}
	@media (min-width: 540px) {
	    .col-sm-five {
	        -webkit-box-flex: 0;
	        -ms-flex: 0 0 20%;
	        flex: 0 0 20%;
	        max-width: 20%;
	    }
	}
	@media (min-width: 720px) {
	    .col-md-five {
	        -webkit-box-flex: 0;
	        -ms-flex: 0 0 20%;
	        flex: 0 0 20%;
	        max-width: 20%;
	    }
	}
	@media (min-width: 960px) {
	    .col-lg-five {
	        -webkit-box-flex: 0;
	        -ms-flex: 0 0 20%;
	        flex: 0 0 20%;
	        max-width: 20%;
	    }
	}
	@media (min-width: 1140px) {
	    .col-xl-five {
	        -webkit-box-flex: 0;
	        -ms-flex: 0 0 20%;
	        flex: 0 0 20%;
	        max-width: 20%;
	    }
	}
</style>
<script>
	import { Select, Option } from 'element-ui'

	export default {
		name: 'revision-technical-details',
		components: {
			[Select.name] : Select,
			[Option.name] : Option,
		},
		props:{
			model: Object,
		},
		methods: {
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
		},
		data() {
			return {
				pistonsArray: [...Array(16)].map(( u,i ) => i + 1 ),
				fields: {
					airFilter : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['','pulito','sostituito','libero'],
						label: 'Filtro Aria'
					} ,
					oilFilter : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['',"Sostituito"],
						label: 'Filtro Olio'
					} ,
					oilConsumption : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'number',
						// values: ['',"filtri sostitui"],
						label: 'Consumo olio lt'
					} ,
					sparkPlugs : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['',"vuoto", "Sostituite","Sabbiate"],
						label: 'Candele'
					} ,
					tappetsRegolation : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['','effettuato'],
						label: 'Regolazione Punterie'
					} ,
					batteriesControl : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'type',
						values: ['','nessuna manutenzione necessaria',' Rabboccate', 'Sostituite','Esaurite/Guaste'],
						label: 'Controllo Batterie'
					} ,
					engineBackPressure : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'type',
						// values: ['',"Nella norma", "Molto usurate"],
						label: 'Controllo pressione motore mbar'
					} ,
					compressor : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'type',
						values: ['',"Ok", "Rabboccato"],
						label: 'Compressore - olio'
					} ,
					checkCondensateDrain: {
						type: "text", //eseguito
						// classes: 'asd col-6 col-md-6 col-lg-3',
						classes: 'col-12',
						// values: ['','eseguito'],
						nativeType: "text",
						label: 'Compressore - condensa'
					},
					alternator : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['',"ingrassato", "usurato", "revisionato"],
						label: 'Alternatore'
					} ,
					oxygenCarburation : {
						type: "type",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'number',
						step: '0.01',
						label: 'Carburazione ossigeno %'
					} ,
					breakthroughControl : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['',"Nella norma", "teste usurate"],
						label: 'Controllo Sfondamenti'
					} ,
					glycolFilterCleaning : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['',"Effettuato","Non necessario", "Non presente"],
						label: 'Pulizia Filtri Glicole'
					} ,
					blowByFilterCleaning : {
						type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['', "sostituito","pulito", "Nessuna manutenzione necessaria"],
						label: 'Filtro blow-by'
					} ,
					glycolEngine : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'text',
						label: 'Glicole motore'
					},
					glycolIntercooler : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'text',
						label: 'Glicole intercooler'
					},
					leftExhaustBackPressureAtmMBar : {
						// type: "select",
						// classes: 'col-12 col-md-6 col-lg-3',
						type: "text",
						classes: 'col-12',
						nativeType: 'number',
						label: 'Contro pressione scarico six atmosfera mbar'
					} ,
					rightExhaustBackPressureAtmMBar : {
						type: "seltextect",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'number',
						label: 'Contro pressione scarico dex atmosfera mbar'
					} ,
					leftExhaustBackPressureRecoverMBar : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'number',
						label: 'Contro pressione scarico six recupero mbar'
					} ,
					rightExhaustBackPressureRecoverMBar : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'number',
						label: '"Contro pressione scarico dex recupero mbar'
					} ,
					engineKw : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						nativeType: 'number',
						// values: ['',"Nella norma", "Molto usurate"],
						label: 'Kw motore'
					} ,
					ch4 : {
						type: "text",
						// classes: 'col-12 col-md-6 col-lg-3',
						placeholder: 'Inserisci commento',
						classes: 'col-12',
						label: 'Ch4%'
					},



					//Spazio
					addSpace : {
						type: "",
						// classes: 'invisible col-12',
						classes: 'col-12',
						label: ''
					},




					// fileds for the report not for the final resume
					oilWaterLeakCheck:{
						type: "select", //eseguita, controllata /risettata
						// classes: 'asd col-12 col-md-5 col-lg-6',
						classes: 'col-12',
						values: ['','effettuato'],
						nativeType: 'type',
						label: 'Verifica perdite acqua / olio'
					},
					//  Rimosso dal pdf
					// carburetionMaxLoadCheck: {
					// 	type: "select", // si, no 
					// 	classes: 'col-12',
					// 	values: ['','effettuato'],
					// 	label: 'Verifica carburazione a massimo carico'
					// },
					//  Rimosso dal pdf

					// o2percentage: {
					// 	type: "text", // si, no 
					// 	nativeType: 'number',
					// 	step: '0.01',
					// 	// classes: 'asd col-4 col-md-2 col-lg-2',
					// 	classes: 'col-12',
					// 	label: 'O2%'						
					// },
					o2emissionsCheck: {
						type: "select", //Nella norma, elevata
						// classes: 'asd col-6 col-md-12 col-lg-6',
						classes: 'col-12',
						values: ['','effettuato'],
						label: 'Verifica emissioni CO'
					},
					
					pressureLevelOrH2OLevels: {
						type: "select", //1, 1\,2
						// classes: 'asd col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['','ok','Rabboccato','Insufficente'],
						label: 'Verifica pressione livello circuito principale'
					},
					pressureLevelOrH2OLevelsCommment: {
						type: "select",
						// classes: 'asd col-12 col-md-6 col-lg-3',
						classes: 'col-12',
						values: ['','ok','non presente','rabboccato'],
						label: 'Verifica pressione livello circuito secondario'
					},
					checkThermometers: {
						type: "select",
						// classes: 'asd col-12 col-md-12',
						classes: 'col-12',
						values: ['','ok','guasti'],
						label: 'Verifica termometri/manometri'
					},
					//  Rimosso dal pdf
					// checkWaterGlycolMixture: {
					// 	type: "select", 
					// 	// classes: 'asd col-12 col-md-6',
					// 	classes: 'col-12',
					// 	values: ['','ottimale','insufficiente'],
					// 	label: 'Verifica miscela acqua/glicole'
					// },
					//  Rimosso dal pdf

					// firstCheckWaterGlycolMixture: {
					// 	type: "type", 
					// 	// classes: 'asd col-12 col-md-3',
					// 	classes: 'col-12',
					// 	// values: ['','ottimale','insufficiente'],
					// 	label: 'Primario'
					// },
					//  Rimosso dal pdf
					// secondCheckWaterGlycolMixture: {
					// 	type: "type", 
					// 	// classes: 'asd col-12 col-md-3',
					// 	classes: 'col-12',
					// 	// values: ['','ottimale','insufficiente'],
					// 	label: 'Secondario'
					// },

					cleanEngineLocalExhaustFans:{
						type: "select", //nella norma/ sporche
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','nella norma', 'effettuato'],
						label: 'Pulizia ventole di estrazione'
					},

					greasingSmokeValve: {
						type: "select", // eseguito, non presenti
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['',"effettuato", "non presenti", "rumorosi"],
						label: 'Ingrassaggio cuscinetti valvola fumi'
					},

					checkPumpsCabinSounds: {
						type: "select", //Nella norma / rumorosi
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','nella norma', 'rumorosi'],
						label: 'Verifica funzionamento manuale / controllo rumori cuscinetti'
					},



					//PAGINA 2

					checkAndCleanRadiatorPack: {
						type: "select", // lavati , molto sporchi, non necessita pulizia
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','Sporchi', 'OK'],
						label: 'Verifica / pulizia radiatori'
					},
					checkRadiatorFans: {
						type: "select", // Nella norma, rumorose
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','nella norma','rumorose'],
						label: 'Verifica funzionamento ventole radiatore'
					},
					checkMufflers: {
						type: "select", // eseguite, nella norma, usurate
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','nella norma','usurate'],
						label: 'Verifica stato marmitte'
					},
					checkSmokeExchanger: {
						type: "select", // Nella norma / occlusi
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','nella norma','occlusi'],
						placeholder: 'Inserisci commento',
						label: 'Verifica apertura scarichi scambiatore fumi'
					},

					//Spazio
					addNewSpace : {
						type: "",
						// classes: 'invisible col-12',
						classes: 'col-12',
						label: ''
					},

					checkGlycolsLiters: {
						type : "type",
						nativeType: 'number',
						// classes: 'asd col-6 col-md-6',
						classes: 'col-12',
						values: ['','ok','guasti'],
						label: 'verifica presenza glicole puro(litri)'
					},

					checkWaterGlycolsLiters: {
						type : "type",
						nativeType: 'number',
						// classes: 'asd col-6 col-md-6',
						classes: 'col-12',
						values: ['','ok','guasti'],
						label: 'verifica presenza miscela acqua/glicole(litri)'
					},

					stockLubricatingOil: {
						type: "type",
						nativeType: 'number', 
						// classes: 'asd col-6 col-md-6',
						classes: 'col-12',
						values: ['','ok','guasti'],
						label: 'olio lubrificante nuovo(litri)'
					},

					stockLubricatingOilonLubeOile: {
						type: "type",
						nativeType: 'number', 
						// classes: 'asd col-6 col-md-6',
						classes: 'col-12',
						values: ['','ok','guasti'],
						label: 'olio lubrificante nel serbatoio(litri)'
					},
					stockLubricatingOilonToppingUpAir: {
						type: "type",
						nativeType: 'number', 
						// classes: 'asd col-6 col-md-6',
						classes: 'col-12',
						values: ['','ok','guasti'],
						label: 'olio lubrificante nel fusto rabboccatore ad aria(litri)'
					},
					mustEmptyOilTank: {
						type : "select", 
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','si','no'],
						placeholder: 'Inserisci commento',
						label: 'necessita di svuotare cisterna olio'
					},


					addAnotherSpace : {
						type: "",
						// classes: 'invisible col-12',
						classes: 'col-12',
						label: ''
					},


					
					checkAbsenceOilOnIntercooler: {
						type: "select", // presente / non presente
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','presente','non presente'],
						label: 'Presenza olio nel condotto intercooler'
					},
					checkEndoscopicValvesAndTubes: {
						type: "select", // Nella norma / Molto usurate
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','Nella norma','Molto usurate'],
						label: 'Verifica endoscopica sedi valvole e stato canne'
					},
					checkEngineHeads: {
						type: "text", //
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						label: 'verifica usura testate'
					},

					checkVasisPressure:{
						type: "select", //
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['',''],
						label: 'verifica usura testate'
					},


					checkCompressorAndTemperatures:{
						type: "select", //
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','Vedi scontrino allegato', 'Compressione insufficente', 'Temperature anomale'],
						label: 'effettuare prova di comporessione e temperature'
					},
					checkVasisPressure:{
						type: "select", //
						// classes: 'asd col-12 col-md-6',
						classes: 'col-12',
						values: ['','effettuato'],
						label: 'Verifica pressione di carica vasi e tenuta membrana (a pressione zero)'
					},
					//  Rimosso dal pdf
					// checkCarterPressureMaxPower:{
					// 	type: "text", //
					// 	// classes: 'asd col-12 col-md-6',
					// 	classes: 'col-12',
					// 	label: 'Verifica contropressione carter alla max potenza impostata in manuale'
					// },
					note : {
						type: "text",
						// classes: 'col-12',
						classes: 'col-12',
						label: 'Note aggiuntive (che finiranno solo nel rapporto riassuntivo)'
					}
				}
			}
		}
	}
</script>